import * as React from "react";
const SvgDeviceHub = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.252 1.68v9.572H4.439l1.235-1.234 1.232-1.235-.531-.531-.533-.533-2.14 2.14L1.56 12l2.14 2.14 2.14 2.141.534-.533.531-.531-1.228-1.23-1.229-1.23h6.803V22.32l.75-.002.752-.004.002-4.777.002-4.78H19.55l-1.229 1.23-1.228 1.23.531.531.533.533 2.14-2.14L22.44 12 20.3 9.86l-2.14-2.141-.534.533-.531.531 1.232 1.235 1.235 1.234h-6.803l-.002-4.783-.002-4.783-.752-.004z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDeviceHub;
